export default "__VITE_ASSET__TkpjeuQN__"